import { isDefined } from "@clipboard-health/util-ts";
import { ON_TIME_BONUS_GRACE_PERIOD_MINUTES } from "@src/appV2/ClipboardScore/constants";
import { addMinutes, isBefore } from "date-fns";

export function getHasWorkerClockedInOnTime(params: {
  shiftStartDate: Date;
  clockInTime: Date | undefined;
}): boolean {
  const { shiftStartDate, clockInTime } = params;

  if (!isDefined(clockInTime)) {
    return false;
  }

  const gracePeriodEnd = addMinutes(shiftStartDate, ON_TIME_BONUS_GRACE_PERIOD_MINUTES);

  return isBefore(clockInTime, gracePeriodEnd);
}
